export enum PaymentResponseStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  // Moment
  PAID = 'PAID',
  CREATED = 'CREATED',
  PAYMENT_SUCCESS = 'PAYMENTSUCCESS',
  PAYMENT_FAILED = 'PAYMENTFAILED',
  // PSO
  PSO_COMPLETED = 'PSOCOMPLETED',
  PSO_RETRYING = 'PSORETRYING',
  PSO_PROCESSING = 'PSOPROCESSING'
}

export const PaymentStatusGroup = {
  notProcessing: [
    PaymentResponseStatus.CREATED,
  ],
  pending: [
    PaymentResponseStatus.CREATED,// FIXME: this should be resolved once Moment sort out their link timeout issues
    PaymentResponseStatus.PENDING,
    PaymentResponseStatus.PAYMENT_SUCCESS,
    PaymentResponseStatus.PSO_RETRYING,
    PaymentResponseStatus.PSO_PROCESSING,
  ],
  success: [
    PaymentResponseStatus.SUCCESS,
    PaymentResponseStatus.PAID,
    PaymentResponseStatus.PSO_COMPLETED,
  ],
  failed: [
    PaymentResponseStatus.FAILURE,
    PaymentResponseStatus.PAYMENT_FAILED,
  ]
}
